import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Star } from 'lucide-react';

export function ReviewsMarquee() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get('/reviews/banner').then(({ data }) => setItems(data.items || [])).catch(() => {});
    }, []);

    if (!items.length) return null;

    const loop = [...items, ...items];

    return (
        <div
            data-testid="reviews-marquee-banner"
            className="fixed bottom-0 inset-x-0 h-12 md:h-14 bg-black/80 backdrop-blur border-t border-white/10 z-40 flex items-center"
        >
            <div className="px-4 text-[10px] md:text-xs font-display tracking-widest text-amber-400/90 border-r border-white/10 mr-3 hidden sm:block">
                5-STAR CLUB
            </div>
            <div className="marquee flex-1">
                <div className="marquee-inner items-center">
                    {loop.map((r, i) => (
                        <div key={`${r.id || r.name}-${i}`} className="inline-flex items-center gap-3 text-sm text-white/90">
                            <span className="inline-flex items-center gap-1 text-amber-400">
                                {Array.from({ length: 5 }).map((_, k) => (
                                    <Star key={`${r.id || r.name}-${i}-star-${k}`} className="w-3.5 h-3.5 fill-current" />
                                ))}
                            </span>
                            <span className="font-semibold">“{r.title || r.body.slice(0, 60)}”</span>
                            <span className="text-white/60">— {r.name}</span>
                            {r.vehicle ? <span className="text-white/40 hidden md:inline">({r.vehicle})</span> : null}
                            <span className="text-white/20">•</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
